import React from 'react';
import styles from './VelocityBadge.module.css';
import { VelocityType } from '../inventoryTypes';

interface VelocityBadgeProps {
  velocity: VelocityType;
}

export const VelocityBadge: React.FC<VelocityBadgeProps> = ({ velocity }) => {
  return (
    <span className={`${styles.badge} ${styles[velocity.toLowerCase()]}`}>
      {velocity}
    </span>
  );
};
